import { callable, mergeComponentVariables, withDebugId } from '@fluentui/styles';
var variablesCache = new WeakMap();

var resolveVariables = function resolveVariables(displayName, theme, variables, enabledVariablesCaching) {
  //
  // Simple caching model, works only if there is no `props.variables`
  // Resolves variables for this component, cache the result in provider
  //
  var componentThemeVariables = {};

  if (enabledVariablesCaching) {
    if (!variablesCache.has(theme)) {
      variablesCache.set(theme, {});
    }

    var variablesThemeCache = variablesCache.get(theme) || {};

    if (!variablesThemeCache[displayName]) {
      variablesThemeCache[displayName] = callable(theme.componentVariables[displayName])(theme.siteVariables) || {};
      variablesCache.set(theme, variablesThemeCache);
    }

    componentThemeVariables = variablesThemeCache[displayName];
  } else {
    componentThemeVariables = callable(theme.componentVariables[displayName])(theme.siteVariables) || {};
  }

  if (variables === undefined) {
    return componentThemeVariables;
  }

  return mergeComponentVariables(componentThemeVariables, withDebugId(variables, 'props.variables'))(theme.siteVariables);
};

export default resolveVariables;